import { accessPermitRelationTypesEnum } from "helpers/enums";
import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/accessPermits";

export const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, orderBy: "id desc" });
    return request(
        `${resource}/getList?withDeleted=true&${query.substr(1)}`,
        { method: "GET" },
        { countInHeaders: true },
    );
};

export const getInfoList = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, orderBy: "id desc" });
    return request(
        `${resource}/getInfoList?withDeleted=false&${query.substr(1)}`,
        { method: "GET" },
        { countInHeaders: true },
    );
};
export const selectList = ({ filter, ...params }: OdataFilters) => {
    if (!filter) {
        filter = { relationType: { ne: accessPermitRelationTypesEnum.NoRelation } };
    }
    return request(`${resource}/getSelectList?withDeleted=false&${containsQuery(params, { filter }).substr(1)}`, {
        method: "GET",
    });
};

export const carSelectList = ({ filter, ...params }: OdataFilters) =>
    request(
        `${resource}/getSelectList?withDeleted=false&${containsQuery(params, { filter: { relationType: accessPermitRelationTypesEnum.Car } }).substr(1)}`,
        { method: "GET" },
    );

export const apply = (params: {}) => alertRequest(`${resource}/apply`, params);
export const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));
export const restore = (params: {}) => alertRequest(`${resource}/restore`, body(params));
export const getItem = ({ id }: { id: string }) => request(`${resource}/get/${id}`, { method: "GET" });
